import styled from 'styled-components';
import { ScreenScrapeButton } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeButton';
import { useHistory } from 'react-router';
import { VerificationPageRoute } from 'src/routes';
import { useEffect } from 'react';
import { ScreenScrapeStepTitle } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeStepTitle';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';
import { useVerificationId } from 'src/common/hooks/useVerificationId';
import { useRedirectUrlQuery } from 'src/pages/VerificationPage/verificationQueries';
import {
  handleRedirect,
  isPartnerFlowWithoutRetry,
} from 'src/common/services/process';

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  ${ScreenScrapeButton} {
    margin-top: auto;
  }
`;

const Text = styled.p`
  line-height: 1.5rem;
  text-align: center;
`;

export const ScreenScrapeLogout = () => {
  const history = useHistory();
  const id = useVerificationId();
  const { data, isLoading } = useRedirectUrlQuery(id);
  const redirect = () => {
    // Partner flow with retry must go through the verification page, so the
    // retry popup can be shown on INSUFFICIENT_DATA (same as SUCCESS_PAGE flow).
    if (data && isPartnerFlowWithoutRetry(data.processFlow, data.processRetry)) {
      handleRedirect(data.redirectUrl);
    } else {
      history.push(VerificationPageRoute);
    }
  };
  const ctx = useSSContext();

  useEffect(() => {
    // Wait for the redirect data, otherwise redirect() runs with stale `data`
    if (isLoading) {
      return;
    }

    const timeout = setTimeout(() => {
      redirect();
    }, 4000);

    return () => clearTimeout(timeout);
  }, [isLoading]);

  return (
    <>
      <ScreenScrapeStepTitle>
        {ctx.lastJsonMessage?.value}
      </ScreenScrapeStepTitle>
      <Container>
        <Text>
          Nie zamykaj okna przeglądarki - po kilku sekundach sesja zakończy się
          automatycznie. Po kliknięciu &quot;OK&quot; przejdziesz na stronę
          internetową AIS Gateway Sp z o.o.
        </Text>
        <ScreenScrapeButton onClick={redirect} disabled={isLoading}>
          OK
        </ScreenScrapeButton>
      </Container>
    </>
  );
};
